<template>
    <a-card style="max-width: 500px;margin: 0 auto;" :head-style="{ textAlign: 'center' }" :title="$t('text.recoverForgotPassword')">
        <a-collapse expand-icon-position="right" accordion>
            <a-collapse-panel :header="$t('text.forgotPasswordUsePass2')">
                <a-form
                    ref="formUsePass2"
                    :model="formModelUsePass2"
                    @finish="onFinishUsePass2"
                    :rules="formRuleUsePass2"
                    :scrollToFirstError="true"
                    layout="vertical"
                >
                    <a-form-item :label="$t('labelText.username')" name="username">
                        <a-input v-model:value="formModelUsePass2.username" />
                    </a-form-item>

                    <a-form-item :label="$t('labelText.user_tel')" name="tel">
                        <a-input v-model:value="formModelUsePass2.tel" />
                    </a-form-item>

                    <a-form-item :label="$t('labelText.password2')" name="password2">
                        <a-input-password v-model:value="formModelUsePass2.password2" />
                    </a-form-item>

                    <a-form-item :label="$t('labelText.new_password')" name="password">
                        <a-input-password v-model:value="formModelUsePass2.password" />
                    </a-form-item>

                    <a-form-item :label="$t('labelText.password_confirm')" name="password_confirm">
                        <a-input-password v-model:value="formModelUsePass2.password_confirm" />
                    </a-form-item>

                    <a-form-item>
                        <a-button type="primary" html-type="submit" block :loading="isLoading">{{ $t('text.changePassword') }}</a-button>
                    </a-form-item>
                </a-form>
            </a-collapse-panel>
            <a-collapse-panel :header="$t('text.forgotPasswordUseEmail')">
                <a-form
                    ref="formUseEmail"
                    :model="formModelUseEmail"
                    @finish="onFinishUseEmail"
                    :rules="formRuleUseEmail"
                    :scrollToFirstError="true"
                    layout="vertical"
                >
                    <a-form-item :label="$t('labelText.username')" name="username">
                        <a-input v-model:value="formModelUseEmail.username" />
                    </a-form-item>

                    <a-form-item>
                        <a-button type="primary" html-type="submit" block :loading="isLoading">{{ $t('text.forgotPasswordUseEmailRequest') }}</a-button>
                    </a-form-item>
                </a-form>
            </a-collapse-panel>
            <a-collapse-panel :header="$t('text.forgotPasswordUseSecurityQuestion')">
                <a-form
                    ref="formUseSecurityQuestion"
                    :model="formModelUseSecurityQuestion"
                    @finish="onFinishUseSecurityQuestion"
                    :rules="formRuleUseSecurityQuestion"
                    :scrollToFirstError="true"
                    layout="vertical"
                >
                    <a-form-item :label="$t('labelText.user_name')" name="username">
                        <a-input v-model:value="formModelUseSecurityQuestion.username" />
                    </a-form-item>

                    <a-form-item :label="$t('labelText.user_question')" name="question">
                        <a-select :options="optionsSecurityQuestion" v-model:value="formModelUseSecurityQuestion.question" />
                    </a-form-item>

                    <a-form-item :label="$t('labelText.user_answer')" name="answer">
                        <a-input v-model:value="formModelUseSecurityQuestion.answer" />
                    </a-form-item>

                    <a-form-item :label="$t('labelText.new_password')" name="password">
                        <a-input-password v-model:value="formModelUseSecurityQuestion.password" />
                    </a-form-item>

                    <a-form-item :label="$t('labelText.password_confirm')" name="password_confirm">
                        <a-input-password v-model:value="formModelUseSecurityQuestion.password_confirm" />
                    </a-form-item>

                    <a-form-item>
                        <a-button type="primary" html-type="submit" block :loading="isLoading">{{ $t('text.changePassword') }}</a-button>
                    </a-form-item>
                </a-form>
            </a-collapse-panel>
        </a-collapse>
    </a-card>
</template>

<script lang="ts">
import { defineComponent, reactive, ref } from 'vue';
import {
    Button, Form, Input, InputPassword, Card, Collapse, Modal, Select,
} from 'ant-design-vue';

import type { RuleObject } from 'ant-design-vue/lib/form';

import ApiRequest from '@/utils/ApiRequest';
import { RouteName, } from '@/router';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { optionsSecurityQuestion } from '@/store/modules/user';

interface FormModelUsePass2 {
    username: string;
    password2: string;
    tel: string;
    password: string;
    password_confirm: string;
}

interface FormModelUseSecurityQuestion {
    username: string;
    question: string;
    answer: string;
    password: string;
    password_confirm: string;
}

interface FormModelUseEmail {
    username: string;
}

export default defineComponent({
    components: {
        AButton: Button,
        AForm: Form,
        AFormItem: Form.Item,
        AInput: Input,
        AInputPassword: InputPassword,
        ACard: Card,
        ACollapse: Collapse,
        ACollapsePanel: Collapse.Panel,
        ASelect: Select,
    },

    setup() {
        const router = useRouter();
        const { t } = useI18n();
        const formUsePass2 = ref<typeof Form>();
        const formUseEmail = ref<typeof Form>();
        const formUseSecurityQuestion = ref<typeof Form>();

        const isLoading = ref(false);

        const formExtraErrorUsePass2: Record<keyof FormModelUsePass2, string> = {
            username: '',
            password2: '',
            tel: '',
            password: '',
            password_confirm: '',
        };
        const formModelUsePass2 = reactive<FormModelUsePass2>({
            username: '',
            password2: '',
            tel: '',
            password: '',
            password_confirm: '',
        });
        const formRuleUsePass2 = reactive<Record<keyof FormModelUsePass2, RuleObject[]>>({
            username: [
                {
                    required: true,
                    trigger: ['blur', 'change'],
                },
                {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    validator: (_rule: any, _value, callback) => callback(formExtraErrorUsePass2[_rule.field as keyof FormModelUsePass2] || undefined),
                },
            ],
            password2: [
                {
                    required: true,
                    trigger: ['blur', 'change'],
                },
                {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    validator: (_rule: any, _value, callback) => callback(formExtraErrorUsePass2[_rule.field as keyof FormModelUsePass2] || undefined),
                },
            ],
            tel: [
                {
                    required: true,
                    trigger: ['blur', 'change'],
                },
                {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    validator: (_rule: any, _value, callback) => callback(formExtraErrorUsePass2[_rule.field as keyof FormModelUsePass2] || undefined),
                },
            ],
            password: [
                {
                    required: true,
                },
                {
                    min: 8,
                    trigger: ['blur', 'change'],
                },
                {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    validator: (_rule: any, _value, callback) => callback(formExtraErrorUsePass2[_rule.field as keyof FormModelUsePass2] || undefined),
                },
            ],
            password_confirm: [
                {
                    required: true,
                    validator: (_rule, value, callback) => callback((value && (value !== formModelUsePass2.password)) ? t('message.passwordNotMatch') : undefined),
                    trigger: ['blur', 'change'],
                },
            ],
        });

        const onFinishUsePass2 = (values: FormModelUsePass2) => {
            isLoading.value = true;

            ApiRequest.post('/forgot-password/use-pass2', values)
                .then(() => {
                    Modal.info({
                        content: t('message.forgotPasswordUsePass2Success'),
                        okText: t('text.login'),
                        onOk: () => {
                            router.push({ name: RouteName.LOGIN });
                        },
                    });
                })
                .catch(err => {
                    ApiRequest.handleError(err, formExtraErrorUsePass2, formUsePass2.value);
                })
                .finally(() => {
                    isLoading.value = false;
                });
        }

        const formExtraErrorUseSecurityQuestion: {[K in keyof FormModelUseSecurityQuestion]?: string} = {
            username: '',
            question: '',
            answer: '',
            password: '',
            password_confirm: '',
        };
        const formModelUseSecurityQuestion = reactive<FormModelUseSecurityQuestion>({
            username: '',
            question: '',
            answer: '',
            password: '',
            password_confirm: '',
        });
        const formRuleUseSecurityQuestion = reactive<{[K in keyof FormModelUseSecurityQuestion]?: RuleObject[]}>({
            username: [
                {
                    required: true,
                },
                {
                    validator: (_rule, _value, callback) => callback(formExtraErrorUseSecurityQuestion.username || undefined),
                },
            ],
            question: [
                {
                    required: true,
                },
                {
                    validator: (_rule, _value, callback) => callback(formExtraErrorUseSecurityQuestion.question || undefined),
                },
            ],
            answer: [
                {
                    required: true,
                },
                {
                    validator: (_rule, _value, callback) => callback(formExtraErrorUseSecurityQuestion.answer || undefined),
                },
            ],
            password: [
                {
                    required: true,
                },
                {
                    validator: (_rule, _value, callback) => callback(formExtraErrorUseSecurityQuestion.password || undefined),
                },
            ],
            password_confirm: [
                {
                    required: true,
                },
                {
                    validator: (_rule, _value, callback) => callback(formExtraErrorUseSecurityQuestion.password_confirm || undefined),
                },
            ],
        });

        const onFinishUseSecurityQuestion = (values: FormModelUseSecurityQuestion) => {
            isLoading.value = true;

            ApiRequest.post('/forgot-password/use-security-question', values)
                .then(() => {
                    Modal.info({
                        content: t('message.forgotPasswordUseSecurityQuestionRequestSent'),
                        okText: t('text.login'),
                        onOk: () => {
                            router.push({ name: RouteName.LOGIN });
                        },
                    });
                })
                .catch(err => {
                    ApiRequest.handleError(err, formExtraErrorUseSecurityQuestion, formUseSecurityQuestion.value);
                })
                .finally(() => {
                    isLoading.value = false;
                });
        }


        const formExtraErrorUseEmail: {[K in keyof FormModelUseEmail]?: string} = {
            username: '',
        };
        const formModelUseEmail = reactive<FormModelUseEmail>({
            username: '',
        });
        const formRuleUseEmail = reactive<{[K in keyof FormModelUseEmail]?: RuleObject[]}>({
            username: [
                {
                    required: true,
                },
                {
                    validator: (_rule, _value, callback) => callback(formExtraErrorUseEmail.username || undefined),
                },
            ],
        });

        const onFinishUseEmail = (values: FormModelUseEmail) => {
            isLoading.value = true;

            ApiRequest.post('/forgot-password/use-email', values)
                .then(() => {
                    Modal.info({
                        content: t('message.forgotPasswordUseEmailRequestSent'),
                        okText: t('text.login'),
                        onOk: () => {
                            router.push({ name: RouteName.LOGIN });
                        },
                    });
                })
                .catch(err => {
                    ApiRequest.handleError(err, formExtraErrorUseEmail, formUseEmail.value);
                })
                .finally(() => {
                    isLoading.value = false;
                });
        }


        return {
            RouteName,

            onFinishUsePass2,
            formModelUsePass2,
            formRuleUsePass2,
            formUsePass2,

            optionsSecurityQuestion,
            onFinishUseSecurityQuestion,
            formModelUseSecurityQuestion,
            formRuleUseSecurityQuestion,
            formUseSecurityQuestion,

            onFinishUseEmail,
            formModelUseEmail,
            formRuleUseEmail,
            formUseEmail,

            isLoading,
        };
    },
})
</script>

<style>

</style>
